import React, { useState } from "react";
import AssignBoatButton from "./AssignBoatButton"
import BoatListByUser from "./BoatListByUser";

import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';


import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Badge from 'react-bootstrap/Badge';

import { IoIosBoat } from "react-icons/io";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import type { User } from "../types/types";


interface UserCardProps {
    user: User;
    handleToggleStatus: (email: string, currentStatus: boolean) => void;
}


const UserCard: React.FC<UserCardProps> = ({user, handleToggleStatus}) => {
  
    const [isExpanded, setIsExpanded] = useState(false);

    const handleToggleBateaux  = () => {
        setIsExpanded(prevState => !prevState)
    }


  return (
            <ListGroup.Item
                key={user.id}
                className={`p-3 border-bottom d-flex align-items-center justify-content-between rounded transition ${
                    user.disabled ? "bg-light opacity-50" : "bg-white"
                  } list-ub`}
            >
                <div>
                    <div className="d-flex align-items-center gap-2">
                        <strong>{user.email}</strong>
                        <Badge pill bg={user.defaultRole === "UserAdmin" ? "danger" : "warning" }>{user.defaultRole}</Badge>
                    </div>
                    {isExpanded && (
                        <BoatListByUser userId={user.id}></BoatListByUser>
                    )}
                </div>
                <div className="d-flex align-items-center g-4">
                    <ButtonGroup>
                        <Button
                            variant="primary"
                            size="sm"
                            className="px-3 py-1 text-white"
                            onClick={() =>handleToggleBateaux()}>
                            <div className="d-flex align-items-center justify-content-between">
                                {isExpanded ? <FaEyeSlash/> : <FaEye/>} <IoIosBoat/>
                            </div>
                        </Button>
                        <AssignBoatButton userId={user.id}></AssignBoatButton>
                        <Button 
                            disabled={user.defaultRole==="UserAdmin"}
                            variant={user.disabled ? "success" : "danger"}
                            size="sm"
                            className="px-3 py-1 text-white"
                            onClick={() => handleToggleStatus(user.email, user.disabled)}
                        >
                            {user.disabled ? "Activer" : "Désactiver"}
                        </Button>
                    </ButtonGroup>
                </div>
            </ListGroup.Item>
    );
};

export default UserCard;
